import * as amplitude from "@amplitude/analytics-browser";
import { Identify, Types } from "@amplitude/analytics-browser";
import { BfSalePhaseTag } from "../bfSale";

// Black Friday 2026: `sale_phase` (early_bf | bfcm | none) on the visitor and
// on every quiz event from the moment the sale state is known, so pricing,
// checkout and trial funnels can be split by sale phase. Server-side events
// (trial_activated from Core) carry it as a user property.
let currentTag: BfSalePhaseTag | null = null;
let pluginAdded = false;

const salePhasePlugin: Types.EnrichmentPlugin = {
  name: "bf2026-sale-phase",
  type: "enrichment",
  setup: async () => undefined,
  execute: async (event: Types.Event) => {
    if (currentTag && event.event_type !== "$identify" && event.event_type !== "$groupidentify") {
      event.event_properties = { ...(event.event_properties ?? {}), sale_phase: currentTag };
    }
    return event;
  },
};

export function setSalePhase(tag: BfSalePhaseTag): void {
  if (!pluginAdded) {
    pluginAdded = true;
    amplitude.add(salePhasePlugin);
  }
  if (currentTag === tag) return;
  currentTag = tag;
  const identify = new Identify();
  identify.set("sale_phase", tag);
  amplitude.identify(identify);
}
